import React from "react";
import "./Dashboard.css";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel"; // Import the VideoCarousel component
import Section_2 from "../Section_2/Section_2";
import Section_3 from "../Section_3/Section_3";
import Section_4 from "../Section_4/Section_4";
import Section_5 from "../Section_5/Section_5";
import Section_6 from "../Section_6/Section_6";
import Section_7 from "../Section_7/Section_7";
import Section_8 from "../Section_8/Section_8";
import Section_9 from "../Section_9/Section_9";
// import HomeCardList from "../Component/HomeCard/HomeCard";
import CustomHomes from "../CustomHomes/CustomHomes";
import AutoCarousel from "../Component/Corosuel";

export default function Dashboard() {
  return (
    <div>
      <div className="section-1-video-carousel-container">
        {/* <VideoCorousel /> */}
        <AutoCarousel />
      </div>

      <Section_2 />
      <Section_3 />
      <Section_4 />
      <Section_5 />
      <Section_6 />
      <Section_7 />
      <Section_8 />
      <Section_9 />
      {/* <CustomHomes/> */}
    </div>
    // /assets/main-video-2.mp4
  );
}
